/* SquareLocator theme script. Small, dependency free, progressive. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function lock(state) { doc.body.classList.toggle('is-locked', !!state); }
  function sGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function sSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------------- Colour scheme ---------------- */
  function initScheme() {
    $$('[data-scheme-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var next = root.getAttribute('data-scheme') === 'dark' ? 'light' : 'dark';
        root.setAttribute('data-scheme', next);
        sSet('sl_scheme', next);
      });
    });
  }

  /* ---------------- Mobile menu ---------------- */
  function initMenu() {
    var menu = $('[data-mnav]');
    if (!menu) return;
    var openers = $$('[data-mnav-open]');
    var lastFocus = null;
    function open() {
      lastFocus = doc.activeElement;
      menu.setAttribute('data-open', 'true');
      menu.setAttribute('aria-hidden', 'false');
      lock(true);
      var first = $('a, button, input', menu);
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      menu.setAttribute('data-open', 'false');
      menu.setAttribute('aria-hidden', 'true');
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    openers.forEach(function (b) { on(b, 'click', open); });
    $$('[data-mnav-close]', menu).forEach(function (b) { on(b, 'click', close); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') close(); });
    on(window, 'resize', debounce(function () { if (window.innerWidth > 1000 && menu.getAttribute('data-open') === 'true') close(); }, 150));
  }

  /* ---------------- Predictive search ---------------- */
  function initPredictive() {
    $$('[data-predictive]').forEach(function (wrap) {
      var input = $('input[type="search"]', wrap);
      var results = $('[data-predictive-results]', wrap);
      if (!input || !results || !window.routes || !window.routes.predictive_search_url) return;
      var controller = null;
      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
        if (controller) controller.abort();
        controller = new AbortController();
        var url = window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=4&resources[options][fields]=title,product_type,vendor,tag,body&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = doc.createElement('div');
            tmp.innerHTML = html;
            var inner = $('#PredictiveSearchResults', tmp);
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !results.innerHTML.trim();
          })
          .catch(function () {});
      }, 220);
      on(input, 'input', run);
      on(input, 'focus', function () { if (results.innerHTML.trim()) results.hidden = false; });
      on(doc, 'click', function (e) { if (!wrap.contains(e.target)) results.hidden = true; });
      on(input, 'keydown', function (e) { if (e.key === 'Escape') { results.hidden = true; } });
    });
  }

  /* ---------------- Details popovers (filters) ---------------- */
  function initPopovers() {
    on(doc, 'click', function (e) {
      $$('details[data-popover][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    on(doc, 'toggle', function (e) {
      var d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.hasAttribute('data-popover') || !d.open) return;
      $$('details[data-popover][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    }, true);
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') $$('details[data-popover][open]').forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  /* ---------------- Collection: facets, sort, load more ---------------- */
  function initCollection() {
    var form = $('form[data-facets]');
    var grid = $('[data-collection-grid]');
    if (!grid) return;
    var sectionId = grid.getAttribute('data-section-id');

    function render(url, mode) {
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      grid.classList.add('is-loading');
      return fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var newGrid = $('[data-collection-grid]', tmp);
          var newToolbar = $('[data-collection-toolbar]', tmp);
          var newFilters = $('[data-facets-wrap]', tmp);
          var newMore = $('[data-load-more-wrap]', tmp);
          var oldMore = $('[data-load-more-wrap]');
          if (mode === 'append') {
            if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
          } else if (newGrid) {
            grid.innerHTML = newGrid.innerHTML;
          }
          var oldToolbar = $('[data-collection-toolbar]');
          if (newToolbar && oldToolbar) oldToolbar.innerHTML = newToolbar.innerHTML;
          if (mode !== 'append') {
            $$('[data-facets-wrap]').forEach(function (oldWrap, i) {
              var key = oldWrap.getAttribute('data-facets-wrap');
              var fresh = (key && $('[data-facets-wrap="' + key + '"]', tmp)) || $$('[data-facets-wrap]', tmp)[i];
              if (fresh) oldWrap.innerHTML = fresh.innerHTML;
            });
          }
          if (oldMore) { if (newMore) oldMore.innerHTML = newMore.innerHTML; else oldMore.innerHTML = ''; }
          grid.classList.remove('is-loading');
          if (mode !== 'append') {
            history.replaceState({}, '', url);
            var top = $('[data-collection-top]');
            if (top && mode === 'filter') {
              var y = top.getBoundingClientRect().top + window.pageYOffset - 16;
              if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
            }
          }
          doc.dispatchEvent(new CustomEvent('sl:collection-updated'));
        })
        .catch(function () { grid.classList.remove('is-loading'); window.location.href = url; });
    }

    function urlFromForm(src) {
      var f = src || $('form[data-facets]');
      var params = new URLSearchParams(new FormData(f));
      var base = f.getAttribute('action') || window.location.pathname;
      var sort = $('[data-sort-select]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      // drop empty values
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var qs = clean.toString();
      return base + (qs ? '?' + qs : '');
    }

    on(doc, 'change', function (e) {
      var f = e.target.closest('form[data-facets]');
      if (f && e.target.matches('input[type="checkbox"], select')) {
        render(urlFromForm(f), 'filter');
      }
      if (e.target.matches('[data-sort-select]')) {
        var f2 = $('form[data-facets]');
        if (f2) render(urlFromForm(), 'sort');
        else {
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', e.target.value);
          u.searchParams.delete('page');
          render(u.pathname + u.search, 'sort');
        }
      }
    });
    on(doc, 'submit', function (e) {
      var f = e.target;
      if (f.matches && f.matches('form[data-facets]')) {
        e.preventDefault();
        render(urlFromForm(f), 'filter');
      }
    });
    on(doc, 'click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        var url = more.getAttribute('href');
        more.setAttribute('aria-disabled', 'true');
        more.textContent = 'Loading…';
        render(url, 'append');
        return;
      }
      var reset = e.target.closest('[data-facets-reset]');
      if (reset) {
        e.preventDefault();
        render(reset.getAttribute('href'), 'filter');
      }
      var apply = e.target.closest('[data-facets-apply]');
      if (apply) {
        e.preventDefault();
        render(urlFromForm(), 'filter');
      }
      var toggle = e.target.closest('[data-sidebar-toggle]');
      if (toggle) {
        var sb = $('[data-sidebar]');
        if (sb) {
          var openNow = sb.getAttribute('data-open') === 'true';
          sb.setAttribute('data-open', openNow ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', openNow ? 'false' : 'true');
        }
      }
      var size = e.target.closest('[data-card-size]');
      if (size) {
        $$('[data-card-size]').forEach(function (b) { b.setAttribute('aria-pressed', b === size ? 'true' : 'false'); });
        grid.setAttribute('data-size', size.getAttribute('data-card-size'));
        sSet('sl_card_size', size.getAttribute('data-card-size'));
      }
    });
    var savedSize = sGet('sl_card_size');
    if (savedSize && $('[data-card-size="' + savedSize + '"]')) {
      $$('[data-card-size]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-card-size') === savedSize ? 'true' : 'false'); });
      grid.setAttribute('data-size', savedSize);
    }
  }

  /* ---------------- Quick look ---------------- */
  function initQuickLook() {
    var modal = $('[data-ql]');
    if (!modal) return;
    var panel = $('[data-ql-panel]', modal);
    var lastFocus = null;
    function open(handle) {
      lastFocus = doc.activeElement;
      modal.setAttribute('data-open', 'true');
      lock(true);
      panel.innerHTML = '<div class="ql__loading">Loading…</div>';
      fetch('/products/' + handle + '?section_id=quick-look')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var inner = $('[data-ql-content]', tmp);
          panel.innerHTML = inner ? inner.innerHTML : '<div class="ql__loading">Sorry, this preview is unavailable.</div>';
          var closeBtn = $('[data-ql-close]', panel);
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        })
        .catch(function () { panel.innerHTML = '<div class="ql__loading">Sorry, this preview is unavailable.</div>'; });
    }
    function close() {
      modal.setAttribute('data-open', 'false');
      lock(false);
      panel.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    on(doc, 'click', function (e) {
      var btn = e.target.closest('[data-quick-look]');
      if (btn) { e.preventDefault(); open(btn.getAttribute('data-quick-look')); return; }
      if (e.target.closest('[data-ql-close]')) { close(); return; }
      if (modal.getAttribute('data-open') === 'true' && e.target === modal) close();
    });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') close(); });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap);
      var panels = $$('[role="tabpanel"]', wrap);
      function activate(tab) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }
      tabs.forEach(function (t) {
        on(t, 'click', function () { activate(t); });
        on(t, 'keydown', function (e) {
          var i = tabs.indexOf(t);
          if (e.key === 'ArrowRight') { tabs[(i + 1) % tabs.length].focus(); activate(tabs[(i + 1) % tabs.length]); }
          if (e.key === 'ArrowLeft') { tabs[(i - 1 + tabs.length) % tabs.length].focus(); activate(tabs[(i - 1 + tabs.length) % tabs.length]); }
        });
      });
      if (location.hash) {
        var target = tabs.filter(function (t) { return '#' + t.getAttribute('aria-controls') === location.hash; })[0];
        if (target) activate(target);
      }
    });
  }

  /* ---------------- Generic client-side filter (extensions hub, courses) ---------------- */
  function initClientFilter() {
    $$('[data-client-filter]').forEach(function (wrap) {
      var cards = $$('[data-filter-item]', wrap);
      var buttons = $$('[data-filter-value]', wrap);
      var search = $('input[data-filter-search]', wrap);
      var count = $('[data-filter-count]', wrap);
      var empty = $('[data-filter-empty]', wrap);
      var active = '';
      var noun = wrap.getAttribute('data-filter-noun') || 'items';
      function apply() {
        var q = search ? search.value.trim().toLowerCase() : '';
        var shown = 0;
        cards.forEach(function (c) {
          var cat = c.getAttribute('data-filter-category') || '';
          var blob = (c.getAttribute('data-filter-search') || '').toLowerCase();
          var ok = (!active || cat.split(' ').indexOf(active) > -1) && (!q || blob.indexOf(q) > -1);
          c.hidden = !ok;
          if (ok) shown++;
        });
        if (count) count.textContent = shown + ' ' + (shown === 1 ? noun.replace(/s$/, '') : noun);
        if (empty) empty.hidden = shown !== 0;
      }
      buttons.forEach(function (b) {
        on(b, 'click', function () {
          active = b.getAttribute('data-filter-value');
          buttons.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          apply();
        });
      });
      if (search) on(search, 'input', debounce(apply, 120));
      apply();
    });
  }

  /* ---------------- Article: table of contents + scrollspy ---------------- */
  function initToc() {
    var toc = $('[data-toc]');
    var body = $('[data-article-body]');
    if (!toc || !body) return;
    var heads = $$('h2', body).filter(function (h) { return h.textContent.trim(); });
    if (heads.length < 2) { var tw = toc.closest('.toc'); if (tw) tw.hidden = true; return; }
    var list = doc.createElement('ul');
    list.className = 'toc__list';
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 40);
      var li = doc.createElement('li');
      var a = doc.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.appendChild(list);
    var links = $$('a', list);
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) current = en.target; });
        if (current) links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current.id); });
      }, { rootMargin: '-10% 0px -70% 0px', threshold: 0 });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------------- Copy to clipboard ---------------- */
  function initCopy() {
    on(doc, 'click', function (e) {
      var btn = e.target.closest('[data-copy]');
      if (!btn) return;
      var text = btn.getAttribute('data-copy') || window.location.href;
      var done = function () { var o = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = o; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(done).catch(done); else done();
    });
  }

  /* ---------------- Read more toggles ---------------- */
  function initReadMore() {
    $$('[data-readmore]').forEach(function (wrap) {
      var body = $('[data-readmore-body]', wrap);
      var btn = $('[data-readmore-btn]', wrap);
      if (!body || !btn) return;
      if (body.scrollHeight <= body.clientHeight + 8) { btn.hidden = true; wrap.setAttribute('data-expanded', 'true'); return; }
      on(btn, 'click', function () {
        var open = wrap.getAttribute('data-expanded') === 'true';
        wrap.setAttribute('data-expanded', open ? 'false' : 'true');
        btn.textContent = open ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------------- Sticky buy bar ---------------- */
  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    var anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.setAttribute('data-visible', en.isIntersecting ? 'false' : 'true'); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------------- Marquee: duplicate items so the loop is seamless ---------------- */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      if (track.getAttribute('data-duplicated')) return;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      items.forEach(function (it) { var c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); track.appendChild(c); });
      track.setAttribute('data-duplicated', 'true');
    });
  }

  /* ---------------- Product media thumbs ---------------- */
  function initMediaThumbs() {
    on(doc, 'click', function (e) {
      var t = e.target.closest('[data-media-thumb]');
      if (!t) return;
      var wrap = t.closest('[data-media]');
      var main = $('[data-media-main]', wrap);
      if (!main) return;
      var src = t.getAttribute('data-src');
      var srcset = t.getAttribute('data-srcset');
      main.src = src;
      if (srcset) main.srcset = srcset;
      $$('[data-media-thumb]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
    });
  }

  /* ---------------- Product recommendations ---------------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (wrap) {
      var url = wrap.getAttribute('data-url');
      if (!url || wrap.getAttribute('data-loaded')) return;
      wrap.setAttribute('data-loaded', 'true');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var inner = $('[data-recommendations]', tmp);
          if (inner && inner.innerHTML.trim()) wrap.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------------- Cart page quantity helpers ---------------- */
  function initCart() {
    on(doc, 'click', function (e) {
      var b = e.target.closest('[data-qty-change]');
      if (!b) return;
      var input = $('input', b.parentNode);
      var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty-change'), 10);
      input.value = Math.max(0, v);
      var f = input.form;
      if (f) f.submit();
    });
    on(doc, 'change', function (e) {
      if (e.target.matches('[data-qty-input]') && e.target.form) e.target.form.submit();
    });
  }

  /* ---------------- Article: turn "go to the thing" links into arrow buttons ---------------- */
  var ARROW_SVG = '<svg class="arr" viewBox="64.64 0.13 11.97 12.06" width="13" height="13" aria-hidden="true" focusable="false"><path fill="currentColor" d="M67.7415 10.3442L76.5893 1.43824L75.2944 0.134438L66.4693 9.0201V0.134438H66.4592H64.6403V10.3442V12.1858H66.4693H71.6943H76.6095V10.3442H67.7415Z"/></svg>';
  var CTA_RE = /^(get|visit|try|buy|shop|view|explore|download|start|book|check out|read our|browse|see|join|claim|sign up|grab|go to|more from)\b/i;

  function isOutbound(a) {
    var h = a.getAttribute('href') || '';
    var self = location.hostname.replace(/^www\./, '') || 'squarelocator.com';
    return /^https?:\/\//i.test(h) && h.indexOf(self) === -1;
  }
  function linkText(a) { return (a.textContent || '').replace(/\s+/g, ' ').trim(); }
  function onlyLinks(el) {
    var clone = el.cloneNode(true);
    $$('a', clone).forEach(function (a) { a.remove(); });
    return !clone.textContent.replace(/[\s|·•–\-]/g, '').length;
  }
  function makeBtn(a, primary) {
    a.classList.add('btn', 'article-btn');
    a.classList.add(primary ? 'article-btn--primary' : 'btn--outline');
    if (!a.querySelector('.arr')) a.insertAdjacentHTML('beforeend', ' ' + ARROW_SVG);
    a.innerHTML = a.innerHTML.replace(/<\/?strong>/g, '');
    return a;
  }
  function ctaRow(links, ref, where) {
    var row = doc.createElement('p');
    row.className = 'article-cta';
    links.forEach(function (a, i) { row.appendChild(makeBtn(a, i === 0)); });
    ref.insertAdjacentElement(where || 'afterend', row);
    return row;
  }

  function initArticleLinks() {
    var body = $('[data-article-body]');
    if (!body || body.hasAttribute('data-links-done')) return;
    body.setAttribute('data-links-done', '');

    // 1. Paragraphs or headings that contain nothing but links become a button row.
    $$('p, h2, h3, h4', body).forEach(function (el) {
      if (el.closest('.article-cta, li, table, figure, blockquote')) return;
      var links = $$('a', el);
      if (!links.length || links.length > 4 || !onlyLinks(el) || el.querySelector('img')) return;
      if (el.tagName !== 'P' && !CTA_RE.test(linkText(links[0]))) return; // keep real headings as headings
      ctaRow(links, el, 'beforebegin');
      el.remove();
    });

    // 2. CTA-style links tucked at the end of a paragraph ("Best fit: ... Get Lawyer") move onto their own line.
    $$('p', body).forEach(function (p) {
      if (p.classList.contains('article-cta') || p.closest('li, table, blockquote')) return;
      var ctas = $$('a', p).filter(function (a) { return CTA_RE.test(linkText(a)); });
      if (!ctas.length) return;
      var last = ctas[ctas.length - 1];
      var after = '';
      var n = last.nextSibling;
      while (n) { after += n.textContent || ''; n = n.nextSibling; }
      if (after.replace(/[\s.!]/g, '').length) return; // only lift links that end the paragraph
      ctas.forEach(function (a) {
        var prev = a.previousSibling;
        if (prev && prev.nodeType === 3) prev.textContent = prev.textContent.replace(/[\s|·•–\-]+$/, ' ');
      });
      ctaRow(ctas, p, 'afterend');
      p.innerHTML = p.innerHTML.replace(/(\s|&nbsp;|<br\s*\/?>)+$/i, '').replace(/[\s.]*$/, '').replace(/([^.!?:])$/, '$1.');
      if (!p.textContent.trim() || p.textContent.trim() === '.') p.remove();
    });

    // 3. Tool sections whose heading links out get a closing "Visit X" button if they don't have one already.
    $$('h2', body).forEach(function (h) {
      var a = $('a', h);
      if (!a || !isOutbound(a)) return;
      var host = (a.hostname || '').replace(/^www\./, '');
      var end = h.nextElementSibling;
      var last = h;
      var hasBtn = false;
      while (end && end.tagName !== 'H2') {
        if ($$('a.article-btn', end).some(function (b) { return (b.hostname || '').replace(/^www\./, '') === host; }) ||
            (end.matches && end.matches('.article-cta') && $$('a', end).some(function (b) { return (b.hostname || '').replace(/^www\./, '') === host; }))) hasBtn = true;
        last = end;
        end = end.nextElementSibling;
      }
      if (hasBtn) return;
      var name = linkText(a);
      var btn = doc.createElement('a');
      btn.href = a.href;
      ['rel', 'target'].forEach(function (k) { if (a.getAttribute(k)) btn.setAttribute(k, a.getAttribute(k)); });
      if (!btn.getAttribute('target')) btn.setAttribute('target', '_blank');
      if (!/noopener/.test(btn.getAttribute('rel') || '')) btn.setAttribute('rel', ((btn.getAttribute('rel') || '') + ' noopener').trim());
      btn.textContent = 'Visit ' + name;
      var rows = [];
      var walker = h.nextElementSibling;
      while (walker && walker.tagName !== 'H2') { if (walker.classList && walker.classList.contains('article-cta')) rows.push(walker); walker = walker.nextElementSibling; }
      var lastRow = rows[rows.length - 1];
      if (lastRow) {
        $$('a.article-btn--primary', lastRow).forEach(function (b) { b.classList.remove('article-btn--primary'); b.classList.add('btn--outline'); });
        lastRow.insertBefore(makeBtn(btn, true), lastRow.firstChild);
        if (last !== lastRow) last.insertAdjacentElement('afterend', lastRow);
      } else {
        ctaRow([btn], last, 'afterend');
      }
    });

    // 4. Every other outbound link gets a small arrow so readers know it leaves the page.
    $$('a', body).forEach(function (a) {
      if (a.classList.contains('btn') || a.querySelector('img') || !isOutbound(a)) return;
      a.classList.add('link-out');
      if (!a.querySelector('.arr')) a.insertAdjacentHTML('beforeend', ARROW_SVG);
    });
  }

  function init() {
    initArticleLinks();
    initScheme();
    initMenu();
    initPredictive();
    initPopovers();
    initCollection();
    initQuickLook();
    initTabs();
    initClientFilter();
    initToc();
    initCopy();
    initReadMore();
    initStickyBar();
    initMarquee();
    initMediaThumbs();
    initRecommendations();
    initCart();
    doc.addEventListener('shopify:section:load', function () { initTabs(); initClientFilter(); initReadMore(); initMarquee(); });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
